var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownarrowBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3529_796",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    width: 16,
    height: 16,
    transform: "rotate(90 16 0)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3529_796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.79853 7.83761C5.58742 7.62556 5.54031 7.38292 5.65719 7.10971C5.77364 6.83605 5.98186 6.69922 6.28186 6.69922L9.71519 6.69922C10.0152 6.69922 10.2234 6.83605 10.3399 7.10971C10.4567 7.38292 10.4096 7.62556 10.1985 7.83761L8.46519 9.57868C8.39853 9.64565 8.3263 9.69587 8.24853 9.72935C8.17075 9.76283 8.08742 9.77958 7.99853 9.77958C7.90964 9.77958 7.8263 9.76283 7.74853 9.72935C7.67075 9.69587 7.59853 9.64565 7.53186 9.57868L5.79853 7.83761Z",
    fill: "#1F7AE0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownarrowBlue);
export default __webpack_public_path__ + "static/media/dropdownarrowBlue.c1dffec9dae3fdd290d0fc8885f835fe.svg";
export { ForwardRef as ReactComponent };